import uuid from '../utils/uuid.js'
import request from 'superagent'
import config from '../config.js'

const sendProgress = (id, progress) => ({
  type: 'FILE_UPLOAD_PROGRESS',
  id: id,
  progress: progress
})

const uploadFailure = (id) => ({
  type: 'FILE_UPLOAD_FAILURE',
  id: id
})

const uploadSuccess = (id) => ({
  type: 'FILE_UPLOAD_SUCCESS',
  id: id
})

const upload = (f, dispatch) => {
  return new Promise((resolve, reject) => {
    let req = request.post(config.API_BASE + f.url)
    .attach('files', f.file)
    .withCredentials()
    .on('progress', (p) => {
      dispatch(sendProgress(f.id, parseFloat(p.percent).toFixed(2)))
    })
    .on('abort', () => dispatch({
      type: 'REMOVE_FILE_UPLOADED',
      id: f.id
    }), 2000)
    .end((err, res) => {
      if ( err || !res.ok ) {
        dispatch(uploadFailure(f.id))
        reject(err || res);
      } else {
        dispatch(uploadSuccess(f.id))
        resolve(res);
      }
      setTimeout(() => dispatch({
        type: 'REMOVE_FILE_UPLOADED',
        id: f.id
      }), 2000)
    })

    req.uploadProgress = 0
    req.uploadStatus = 'INPROGRESS'
    req.id = f.id
    req.uploadName = f.file.name

    dispatch({
      type: 'FILES_ENQUEUE',
      file: req
    })
  })
}

export const filesUpload = (files, url) => dispatch => {
  files = files.map((f) => ({
    id: uuid(), 
    url: url,
    file: f
  }))
  return Promise.all(files.map((f) => upload(f, dispatch)))
}
